
import styles from './logo_listing.module.sass'

import BlockWrapper from './layout/block_wrapper'
import Image from './basic/image'
import ScrollAnimation from './layout/scroll_animation'
import Button from './basic/button'

function LogoListing(props) {
	const fields = props.fields

	return <BlockWrapper {...props} className={styles.logo_listing}>
		<ScrollAnimation styles={styles}>
			<div className={styles.listing_wrapper}>
				{fields.list_items.map((feature, i) => {
					return <div key={i} className={styles.list_item_wrapper}>
						{feature.image?.url &&
							<div className={styles.image}>
								<Image {...feature.image} settings={{texture: false}} className={styles.image} />
							</div>
						}
						<div className={styles.content_wrapper}>
							<h3>{feature.title}</h3>
							<div className={styles.content} dangerouslySetInnerHTML={{__html: feature.content}}></div>
							{feature.link.title &&
								<Button fields={{button: feature.link}} button_style='style_2' color='green' className={styles.button}>{feature.link.title}</Button>
							}
						</div>
					</div>
				})}
			</div>
		</ScrollAnimation>
	</BlockWrapper>
}

export default LogoListing